import { IconProps } from './icons-props';

function LeftArrowIcon({ className, width = 8, height = 16 }: IconProps) {
    return (
        <svg className={className} width={width} height={height} viewBox='0 0 6 12' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.37226 11.0429C4.14531 11.0437 3.93023 10.9417 3.78726 10.7654L0.164757 6.26545C-0.0627313 5.9887 -0.0627313 5.5897 0.164757 5.31295L3.91476 0.812948C4.17985 0.494004 4.65331 0.450352 4.97226 0.715448C5.2912 0.980545 5.33485 1.454 5.06976 1.77295L1.71726 5.79295L4.95726 9.81295C5.14453 10.0377 5.18398 10.3509 5.05832 10.6151C4.93265 10.8793 4.66481 11.0464 4.37226 11.0429Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default LeftArrowIcon;

